import {styled} from '@linaria/react';
import {COLORS} from '../../../../../constants/colors';
import {WishButton} from '../../../../molecules/WishButton/WishButton';

/**
 * @deprecated This component is deprecated because it violates best practices defined in the @aboutyou/ui-components.
 * Do not take inspiration from this component for new implementations.
 */
export const DeliveryWishlistButton = styled(WishButton)`
  &&& {
    width: 24px;
    height: 24px;
    padding: 0.3125rem;
    position: absolute;
    top: 0.375rem;
    right: 0.375rem;
    transition: opacity 300ms ease-in;
    background: none;
    fill: ${COLORS.Grey1};

    &:focus-visible {
      outline: 2px auto Highlight;
      outline: 2px auto -webkit-focus-ring-color;
    }
  }
`;
